import React from "react";
import Page from "./../components/Page";
import Section from "./../components/Section";
import SEO from "./../components/SEO";
import WithSideNav from "../components/WithSideNav";
import { CardRow } from "../components/Card";

const latestReleaseCards = [
  {
    title: "v3.13.0 (Latest)",
    description:
      "July 2026 - Smart Scrollbar, New Study List, Appearance Themes & UI-next, and Cornerstone 5.0",
    link: "/release-notes/3p13"
  }
];

const recentReleaseCards = [
  {
    title: "v3.12.0",
    description:
      "February 2026 - Contour Segmentation Tools, Combine & Modify Multiple Segments, and Unified Panel",
    link: "/release-notes/3p12"
  },
  {
    title: "v3.11.0",
    description:
      "August 2025 - Multimodality Fusion, New Ultrasound Mode, and Advanced RT Workflows",
    link: "/release-notes/3p11"
  },
  {
    title: "v3.10.0",
    description:
      "April 2025 - AI-powered segmentation tools and UI improvements",
    link: "/release-notes/3p10"
  }
];

const olderReleaseCards = [
  {
    title: "v3.9.0",
    description: "Enhanced performance and new measurement capabilities",
    link: "/release-notes/3p9"
  },
  {
    title: "v3.8.0",
    description: "Major architectural improvements and bug fixes",
    link: "/release-notes/3p8"
  },
  {
    title: "v3.7.0",
    description: "Feature updates and stability improvements",
    link: "/release-notes/3p7"
  },
  {
    title: "Previous Releases",
    description: "Browse release notes from earlier versions",
    link: "/release-notes/previous"
  }
];

function ReleaseNotes() {
  return (
    <Page>
      <Section>
        <WithSideNav sideNavType="community" title="Release Notes">
          <SEO title="Release Notes | OHIF" />
          <div className="text-white">
            At OHIF, we strive for consistent and dependable releases to keep
            your medical imaging workflows cutting-edge and reliable. Within
            this page, you'll discover a comprehensive list of our latest and
            past releases, complete with detailed release notes.
          </div>

          <div className="flex flex-col space-y-16 mt-8">
            <div>
              <h2 className="text-3xl text-blue-100 mb-4">Latest Release</h2>
              <CardRow cards={latestReleaseCards} className="sm:w-full" />
            </div>

            <div>
              <h2 className="text-3xl text-blue-100 mb-4">Recent Releases</h2>
              <CardRow cards={recentReleaseCards} className="sm:w-1/3" />
            </div>

            <div>
              <h2 className="text-3xl text-blue-100 mb-4">Older Versions</h2>
              <CardRow cards={olderReleaseCards} className="sm:w-1/2" />
            </div>
          </div>
        </WithSideNav>
      </Section>
    </Page>
  );
}

export default ReleaseNotes;
